export default function makeInitStoresFn(storeMap) {
    return function initStores(overrides = {}, useLocalStorage = true) {
        return Object.entries(storeMap).reduce((res, [key, Store]) => {
            res[key] = new Store(overrides[key], useLocalStorage, res);
            return res;
        }, {});
    };
}
